<template>

    <div class="textarea-variable">
        <div class="toolbar">
            <v-var-selector :toggle="varToggle" :target="varTarget" @close="varToggle = null" />
            <v-button ref="toggle" class="toggle" size="xs" btn-style="white" tabindex="-1" @click.native="insertVar">Variable</v-button>
        </div>
        <v-textarea ref="message" placeholder="Type a message..." :rows="rows" :model="model" @input="$emit('input', $event)" />
    </div>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .textarea-variable {
        position: relative;
        .toolbar {
            background: $color-bg;
            border: 1px solid $color-rule;
            border-bottom: none;
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
            display: flex;
            justify-content: flex-end;
            padding: 5px;
            position: relative;
        }
        textarea {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        rows: {
            type: Number,
            default: 5,
        },
    },

    data() {
        return {
            varToggle: null,
            varTarget: null,
        }
    },

    methods: {

        insertVar() {
            if (!this.varToggle) {
                this.varToggle = this.$refs.toggle.$el;
                this.varTarget = this.$refs.message.$el;
            } else {
                this.varToggle = null;
            }
        },

    }

}

</script>
